import React, {useState, useEffect} from 'react';
import FormControl from 'react-bootstrap/FormControl';
import { FaAngleLeft, FaAngleRight, FaAngleUp, FaPrint, FaFile, FaToggleOn, FaToggleOff, FaBook} from 'react-icons/fa';
import Nav from 'react-bootstrap/Nav';
import axios from 'axios';
import { getNavInfo } from './queries';
import { runQuery } from '../utils'


//either supply the resource id, in which case the component will look up the next, prev, string values
// or supply the next prev and up values as props
interface MyComponentProps {
  next?: string,
  prev?: string,
  up?: string,
  selectionRange?: any,
  resourceid: string, // currently needs to be expression id, may include @word-range
  mtFocus?: string,
  handleChangeInfo?: any,
  title?: string,
  longTitle?: string
  blockParent?: string
  handleChangeView?: any
  view?: any // obect {view: "web" or "print" or epub, useCache: true or false}
  displayType?: string
}

const axiosFetcher = (url: string) => axios.post(url).then((res) => {

  const bindings = res.data.results.bindings[0]
  return {
    next: bindings?.next.value, 
    prev: bindings?.prev.value, 
    up: bindings?.parent.value
  }
})

export const ResourceNav: React.FC<MyComponentProps> = (props) => {
  // get resource id without word range
  const resourceid: string = props.resourceid?.split("@")[0]
  // get word range if it exists
  const wordRangeString: string = props.resourceid?.split("@")[1]

  const [customResourceTarget, setCustomResourceTarget] = useState("")
  // const [showCustomResourceTarget, setShowCustomResourceTarget] = useState(false)

  const [next, setNext] = useState<string>(props?.next || "");
  const [prev, setPrev] = useState<string>(props?.prev || "");
  const [up, setUp] = useState<string>(props?.up || "");
  const [title, setTitle] = useState<string>(props?.title || "");
  const [longTitle, setLongTitle] = useState<string>(props?.longTitle || "");

  const [usePrintCache, setUsePrintCache] = useState(props.view?.useCache || true)

  useEffect(() => {
    if (resourceid){
      if (!props.next || !props.prev || !props.up || !props.title){
        getData()
      }
    }
  }, [props.resourceid])



  const getData = () => {
    if (resourceid){
      runQuery(getNavInfo(resourceid)).then((data) => {
      const bindings = data.data.results.bindings[0]
      const next = (bindings?.next && bindings?.next.value !== "http://scta.info/resource/" && !wordRangeString)  ? bindings.next.value + (props?.mtFocus || "") : ""
      const prev = (bindings?.prev && bindings?.prev.value !== "http://scta.info/resource/" && !wordRangeString) ? bindings.prev.value + (props?.mtFocus || "") : ""
      let up: any
      if (wordRangeString){
        up = resourceid
      }
      else{
        up = (bindings?.parent && bindings?.parent.value !== "http://scta.info/resource/") ? bindings.parent.value + (props?.mtFocus || "") : ""
      }
      setNext(next)
      setPrev(prev)
      setUp(up)
      setTitle(bindings?.title?.value)
      setLongTitle(bindings?.longTitle?.value)
    })
   }
  }
  const handelOnEnterPress = (e: any) => {
    if (e.key === 'Enter') {
      let target = e.target.value
      if (target.includes("https://scta.info/resource/")){
        target = target.replace("https://scta.info/resource/", "http://scta.info/resource/")
      }
      if (target.includes("http://scta.info/resource/")){
        target = target
      }
      else if (target.includes("-") || target.includes("*")){
        target = "http://scta.info/resource/" + target.replace("*", "")
      }
      // else if (target.includes("http://scta.info/resource/")){
      //   target = target
      // }
      else(
        target 
      )
      props.handleChangeInfo(target)
      setCustomResourceTarget("")
    }
  }
  return (
    <>
    <Nav variant="tabs">
      <Nav.Item>
        {props.resourceid && <Nav.Link title="refocus on current resource" onClick={() => {props.handleChangeInfo(props.resourceid)}}>{longTitle}</Nav.Link>}
      </Nav.Item>
    </Nav>
    <Nav variant="tabs">
      <Nav.Item>
        {prev && <Nav.Link title="Move Back to Previous Sibling Resource" onClick={() => {props.handleChangeInfo(prev)}}><FaAngleLeft/></Nav.Link>}
      </Nav.Item>
      <Nav.Item>
        {next && <Nav.Link title="Move Forward to Next Sibling Resource" onClick={() => {props.handleChangeInfo(next)}}><FaAngleRight/></Nav.Link>}
      </Nav.Item>
      <Nav.Item>
        {up && <Nav.Link title="Move Up to Parent Resource" onClick={() => {props.handleChangeInfo(up)}}><FaAngleUp/></Nav.Link>}
      </Nav.Item>
      <Nav.Item><Nav.Link>Go to <FaAngleRight/><FormControl style={{display: "inline", padding: "0 0.5rem", width: "inherit"}} type="text" value={customResourceTarget} placeholder="supply scta resource id" className="mr-sm-2" onKeyUp={((e) => {handelOnEnterPress(e)})} onChange={(e) => {setCustomResourceTarget(e.target.value)}}/></Nav.Link></Nav.Item>
      {
      (props.displayType === "item" || props.displayType === "collection") &&
      <>
        
          {(props.view.view === "print" || props.view.view == "epub") 
          ? 
          <Nav.Item><Nav.Link title="Show Web View" onClick={() => {props.handleChangeView({view: "web", useCache: usePrintCache})}}><FaFile/></Nav.Link> </Nav.Item>
          : 
          <>
          <Nav.Item>
            <Nav.Link title="Show PDF/Print View" onClick={() => {props.handleChangeView({view:"print",useCache: usePrintCache})}}><FaPrint/></Nav.Link> 
          </Nav.Item>
          <Nav.Item>
            <Nav.Link title="Show Epub View" onClick={() => {props.handleChangeView({view:"epub",useCache: usePrintCache})}}><FaBook/></Nav.Link>
          </Nav.Item>
          </>
        }
        
        <Nav.Item>{props.view.view === "web" && (!usePrintCache ? <Nav.Link title="currently not using print cache; toggle on to use print cache (if available)" onClick={() => {setUsePrintCache(true)}}><FaToggleOff/></Nav.Link> : <Nav.Link title="currently using print cache; toggle off to not use print cache (if available)" onClick={() => {setUsePrintCache(false)}}><FaToggleOn/></Nav.Link>)}</Nav.Item>
        
      </>
      }
      </Nav>
    </>
    
  )

}

